import { ErrorData } from '../../types';
export let RoutingAction = /*#__PURE__*/function (RoutingAction) {
  RoutingAction["REROUTE"] = "REROUTE";
  RoutingAction["CONTINUE"] = "CONTINUE";
  RoutingAction["DROP"] = "DROP";
  return RoutingAction;
}({});
export let RoutingActionReason = /*#__PURE__*/function (RoutingActionReason) {
  RoutingActionReason["ERROR_IS_HANDLED"] = "ERROR_IS_HANDLED";
  RoutingActionReason["HANDLER_MATCH"] = "HANDLER_MATCH";
  RoutingActionReason["NO_ARTIFACTS_IN_STACKTRACE"] = "NO_ARTIFACTS_IN_STACKTRACE";
  RoutingActionReason["NO_REGISTERED_ARTIFACTS_IN_STACKTRACE"] = "NO_REGISTERED_ARTIFACTS_IN_STACKTRACE";
  RoutingActionReason["BLACKLISTED_SCRIPT_TYPE"] = "BLACKLISTED_SCRIPT_TYPE";
  RoutingActionReason["EXACT_REROUTE_MATCH"] = "EXACT_REROUTE_MATCH";
  RoutingActionReason["HANDLER_REROUTE_MATCH"] = "HANDLER_REROUTE_MATCH";
  RoutingActionReason["FALLBACK_REROUTE_MATCH"] = "FALLBACK_REROUTE_MATCH";
  return RoutingActionReason;
}({});
//# sourceMappingURL=sentry-plugin-types.js.map